export default __webpack_public_path__ + "assets/audios/14d8e40dfe46240590384ccb581351f4.mp3";